module.exports = __webpack_public_path__ + "img/Thunder.8dd689d4.svg";